import { RouteConfig } from "vue-router";

const documentAccessRoutes: RouteConfig[] = [
  {
    path: "",
    name: "documentAccess",
    meta: {
      title: "meta.documentAccess",
      authorize: [],
      tile: "documentAccess",
    },
    component: () =>
      import(
        /* webpackChunkName: "documentAccess" */ "@/components/documentAccess/AccessRightList.vue"
      ),
  },
  {
    path: "search",
    name: "documentAccessSearch",
    meta: {
      title: "meta.documentAccessSearch",
      authorize: [],
      tile: "documentAccess",
    },
    component: () =>
      import(
        /* webpackChunkName: "documentAccess" */ "@/components/documentAccess/ProviderSearch.vue"
      ),
  },
  {
    path: "new",
    name: "documentAccessDetails",
    meta: {
      title: "meta.documentAccessDetails",
      authorize: [],
      tile: "documentAccess",
    },
    component: () =>
      import(
        /* webpackChunkName: "documentAccess" */ "@/components/documentAccess/AccessRightDetails.vue"
      ),
  },
  {
    path: ":id/edit",
    name: "documentAccessDetailsEdit",
    meta: {
      title: "meta.documentAccessDetailsEdit",
      authorize: [],
      tile: "documentAccess",
    },
    component: () =>
      import(
        /* webpackChunkName: "documentAccess" */ "@/components/documentAccess/AccessRightDetails.vue"
      ),
  },
];

export default documentAccessRoutes;
